/**
 * InitiativeCompare JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class InitiativeCompare
 */
class InitiativeCompare {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get the Initiative compare section
        this.compareSection = $( '.initiative-compare' );

        // Get the tabs
        this.tabSection = this.compareSection.find( '.js-tab-section' );
        this.singleTab  = this.compareSection.find( '.js-single-tab' );

        // Get the tab buttons
        this.tabButton = this.compareSection.find( '.js-tab-button' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Change tabs when clicking a tab navigation button
        this.tabButton.on( 'click', ( e ) => {

            Theme.Common.stop( e );

            // Get the name of the tabs to be controlled
            const tabSection = $( e.currentTarget ).parents( '.js-tab-section' );

            // Get the id of the tab to show
            const tabToShow = $( e.currentTarget ).attr( 'href' );

            // Set the clicked tab as the active one, clear active status from siblings.
            // Control aria-selected accordingly.
            $( e.currentTarget ).addClass( 'active-tab' );
            $( e.currentTarget ).attr( 'aria-selected', 'true' );

            // To get the siblings, you have to move one level up to the parent and find its
            // siblings. Then go one level down to remove class from the actual link.
            // Set the siblings as not active. Control aria-selected accordingly.
            const currentButtonSiblings = $( e.currentTarget ).parent().siblings().children();
            currentButtonSiblings.removeClass( 'active-tab' );
            currentButtonSiblings.attr( 'aria-selected', 'false' );

            // Control the tabs to open
            this.tabOpener( tabSection, tabToShow );
        });
    }

    /**
     * Opens and closes tabs
     *
     * @param {string} tabSection The name of the section to be controlled
     * @param {string} tabToShow The name of the tab to be shown
     */
    tabOpener( tabSection, tabToShow ) {
        tabSection.find( this.singleTab ).addClass( 'js-hidden' );
        $( tabToShow ).removeClass( 'js-hidden' );
    }

    /**
     * Hide tabs upon init, only show the first one
    */
    showOnlyFirstTabOnLoad() {

        // Hide all tabs
        this.singleTab.addClass( 'js-hidden' );

        // Show the first tab of a tab section
        this.tabSection.each( ( e, item ) => {
            const tabSectionName = $( item ).data( 'tab-name' );

            // Remove the hidden class from all the first tabs
            $( '#' + tabSectionName + '-0' ).removeClass( 'js-hidden' );

            // Set the first tab button as the active one. Set aria selected as true.
            $( '#' + tabSectionName + '-button-0' ).addClass( 'active-tab' );
            $( '#' + tabSectionName + '-button-0' ).attr( 'aria-selected', true );
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.showOnlyFirstTabOnLoad();
    }
}

// Export the class reference.
module.exports = InitiativeCompare;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/initiative-compare.js